<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportDelayDeliveryInstructions"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterCustomerIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer Id " id="filter-" size="sm" :model.sync="filter.filterCustomerId" @input="getFilterCustomerIds" @focus="getFilterCustomerIds" />
						<app-input-combobox-autocomplete :options="filterDestinationIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination Id " id="filter-" size="sm" :model.sync="filter.filterDestinationId" @input="getFilterDestinationIds" @focus="getFilterDestinationIds" />
						<app-input-textbox id="fieldset-filter-di-number" label-cols-sm="4" label-cols-lg="3" label="Di Number " label-for="filter-filter-di-number" size="sm" :model.sync="filter.filterDiNumber" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-filter-po-no-customer" label-cols-sm="4" label-cols-lg="3" label="Po No Customer " label-for="filter-filter-po-no-customer" size="sm" :model.sync="filter.filterPoNoCustomer" />
						<app-input-combobox-autocomplete :options="filterPartIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Id " id="filter-" size="sm" :model.sync="filter.filterPartId" @input="getFilterPartIds" @focus="getFilterPartIds" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportDelayDeliveryInstructions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Delay Delivery Instruction</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportdelaydeliveryinstruction" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportDelayDeliveryInstructions" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportDelayDeliveryInstructions.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Customer Name" class="table-filter">
							<!-- <b-form-input id="input-customer-name-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportDelayDeliveryInstructionsWithoutLoading" :options="filterCustomerIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer Id " id="filter-" size="sm" :model.sync="filter.filterCustomerId" @input="getFilterCustomerIds" @focus="getFilterCustomerIds" />
						</b-th>
						<b-th stacked-heading="Destination Name" class="table-filter">
							<!-- <b-form-input id="input-destination-name-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.destinationName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportDelayDeliveryInstructionsWithoutLoading" :options="filterDestinationIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination Id " id="filter-" size="sm" :model.sync="filter.filterDestinationId" @input="getFilterDestinationIds" @focus="getFilterDestinationIds" />
						</b-th>
						<b-th stacked-heading="DI Number" class="table-filter">
							<b-form-input id="input-di-number-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.filterDiNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="PO NO Customer" class="table-filter">
							<b-form-input id="input-po-no-customer-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.filterPoNoCustomer" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="DI Delivery Date" class="table-filter">
							<!-- <b-form-input id="input-di-delivery-date-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.diDeliveryDate" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Part Number" class="table-filter">
							<!-- <b-form-input id="input-part-number-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Part Name" class="table-filter">
							<!-- <b-form-input id="input-part-name-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.partName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Qty Delivery" class="table-filter">
							<!-- <b-form-input id="input-qty-delivery-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.qtyDelivery" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Qty Actual Supply" class="table-filter">
							<!-- <b-form-input id="input-qty-actual-supply-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.qtyActualSupply" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Qty Outstanding" class="table-filter">
							<!-- <b-form-input id="input-qty-outstanding-table" @input="getReportDelayDeliveryInstructionsWithoutLoading" v-model="filter.qtyOutstanding" size="sm"></b-form-input> -->
						</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					
					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>

					<template v-slot:cell(diDeliveryDate)="row">
						{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-di-number" label-cols-lg="12"  label="DI Number" label-for="input-di-number" size="sm" :model.sync="row.item.diNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO NO Customer" label-for="input-po-no-customer" size="sm" :model.sync="row.item.poNoCustomer"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-di-delivery-date" label-cols-lg="12"  label="DI Delivery Date" label-for="input-di-delivery-date" size="sm" :model.sync="row.item.diDeliveryDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="Part Number" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-name" label-cols-lg="12"  label="Part Name" label-for="input-part-name" size="sm" :model.sync="row.item.partName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-delivery" label-cols-lg="12"  label="Qty Delivery" label-for="input-qty-delivery" size="sm" :model.sync="row.item.qtyDelivery"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-actual-supply" label-cols-lg="12"  label="Qty Actual Supply" label-for="input-qty-actual-supply" size="sm" :model.sync="row.item.qtyActualSupply"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-outstanding" label-cols-lg="12"  label="Qty Outstanding" label-for="input-qty-outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportDelayDeliveryInstructionsPaging != null ? reportDelayDeliveryInstructionsPaging.dataCount : 0)"
											  :per-page="(reportDelayDeliveryInstructionsPaging != null ? reportDelayDeliveryInstructionsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportdelaydeliveryinstruction.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportdelaydeliveryinstruction.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportDelayDeliveryInstruction from '@/models/ReportDelayDeliveryInstruction/ReportDelayDeliveryInstruction';
import ReportDelayDeliveryInstructionList from '@/models/ReportDelayDeliveryInstruction/ReportDelayDeliveryInstructionList';
import ReportDelayDeliveryInstructionFilter from '@/filters/ReportDelayDeliveryInstruction/ReportDelayDeliveryInstructionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportDelayDeliveryInstruction, 
		ReportDelayDeliveryInstructionList, 
		ReportDelayDeliveryInstructionFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"customerName": {}, "class" : "th-customer-name first-child", "label" : "Customer Name", key: 'customerName', }, 
				{"destinationName": {}, "class" : "th-destination-name", "label" : "Destination Name", key: 'destinationName', }, 
				{"diNumber": {}, "class" : "th-di-number last-child", "label" : "DI Number", key: 'diNumber', }, 
				{"poNoCustomer": {}, "class" : "th-po-no-customer d-stack-none", "label" : "PO NO Customer", key: 'poNoCustomer', }, 
				{"diDeliveryDate": {}, "class" : "th-di-delivery-date d-stack-none", "label" : "DI Delivery Date", key: 'diDeliveryDate', }, 
				{"partNumber": {}, "class" : "th-part-number d-stack-none", "label" : "Part Number", key: 'partNumber', }, 
				{"partName": {}, "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', }, 
				{"qtyDelivery": {}, "class" : "th-qty-delivery d-stack-none", "label" : "Qty Delivery", key: 'qtyDelivery', }, 
				{"qtyActualSupply": {}, "class" : "th-qty-actual-supply d-stack-none", "label" : "Qty Actual Supply", key: 'qtyActualSupply', }, 
				{"qtyOutstanding": {}, "class" : "th-qty-outstanding d-stack-none", "label" : "Qty Outstanding", key: 'qtyOutstanding', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportDelayDeliveryInstructions: [],
			reportDelayDeliveryInstructionsPaging: {},
			filterCustomerIds : [],
			filterDestinationIds : [],
			filterPartIds : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},	methods : {
		getReportDelayDeliveryInstructions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportDelayDeliveryInstruction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportDelayDeliveryInstructions = result.data
					this.reportDelayDeliveryInstructionsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportDelayDeliveryInstructionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportDelayDeliveryInstruction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportDelayDeliveryInstructions = result.data
					this.reportDelayDeliveryInstructionsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterCustomerIds : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDelayDeliveryInstruction.getListCustomUrl(this,'getlistfiltercustomerid' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomerIds = result.data
				}
			})
			.catch(error => {});
		},
		getFilterDestinationIds : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDelayDeliveryInstruction.getListCustomUrl(this,'getlistfilterdestinationid' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterDestinationIds = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartIds : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDelayDeliveryInstruction.getListCustomUrl(this,'getlistfilterpartid' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartIds = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportDelayDeliveryInstructionFilter();
			this.getReportDelayDeliveryInstructions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportDelayDeliveryInstructions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportDelayDeliveryInstruction.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportDelayDeliveryInstruction.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportDelayDeliveryInstruction.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportDelayDeliveryInstruction.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportDelayDeliveryInstructions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportDelayDeliveryInstruction.deleteMultipleData(this).then(result => {
					this.getReportDelayDeliveryInstructions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportDelayDeliveryInstructionParent = document.getElementById('table-list-reportdelaydeliveryinstruction').parentNode;
			tableReportDelayDeliveryInstructionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportDelayDeliveryInstructionParent.scrollWidth - tableReportDelayDeliveryInstructionParent.offsetWidth) == Math.ceil(tableReportDelayDeliveryInstructionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportDelayDeliveryInstructionParent = document.getElementById('table-list-reportdelaydeliveryinstruction').parentNode;
			tableReportDelayDeliveryInstructionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportDelayDeliveryInstructionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportDelayDeliveryInstructionFilter();
		this.getFilterCustomerIds()
		this.getFilterDestinationIds()
		this.getFilterPartIds()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Delay Delivery Instruction"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportDelayDeliveryInstructions();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportDelayDeliveryInstructions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportDelayDeliveryInstructions();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportDelayDeliveryInstructions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportDelayDeliveryInstructions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportDelayDeliveryInstruction.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportdelaydeliveryinstructionindex") {
					this.getReportDelayDeliveryInstructionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_delay_delivery_instruction").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
